import testimonials from '../components/testimonials.svelte'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {
		const $testimonialsSection = $('#testimonialsSection')
		if ($testimonialsSection.length) {
			new testimonials({
				target: $testimonialsSection[0],
				props: $testimonialsSection.data(),
			})
		}

		let $testimonialItems = $('.testimonials-item')
		if ($testimonialItems.length) {
			document.querySelectorAll('.testimonials-item').forEach((item, index) => {
				gsap.fromTo(
					item,
					{ y: 50, opacity: 0 },
					{
						scrollTrigger: item,
						delay: 0.5,
						duration: 0.5,
						y: 0,
						opacity: 1,
					}
				)
			})
		}
	},
	finalize() {},
}
